import { ObjectContainerClientT, ObjectTypeCollectionItemT } from 'bovaljaren-models';
import React, { ReactElement, useState } from 'react';
import { objectTypePropertySorting } from '../../../../../utils/objectType.helper';

type ObjectVieMobileDescriptionProps={
    selectedObject: ObjectContainerClientT;
    types?: ObjectTypeCollectionItemT[];
    showDescription: boolean;
    setShowDescription: (value: boolean) => void;
};

const ObjectViewMobileDescription: React.FC<ObjectVieMobileDescriptionProps> = ({ selectedObject, types, showDescription, setShowDescription }): ReactElement => {

    return (
        <div className={`bv-objectview-mobile-description ${!showDescription ? ' bv-objectview-mobile-description--cropped' : ''}`}>
            <>
                {selectedObject.data
                    .slice()
                    .filter(v => v.value !== null)
                    .filter(v => types?.find(t => t.id === selectedObject.objectTypeId) ? types?.find(t => t.id === selectedObject.objectTypeId)?.properties.find(p => v.propId === p.id) : true)
                    .sort(objectTypePropertySorting)
                    .map(d => {
                        const property = types?.find(t => t.id === selectedObject.objectTypeId)?.properties.find(p => p.id === d.propId);

                        return ({ ...property, ...d });
                    })
                    .filter(d => d.type === 'description' || d.type === 'richDescription')
                    .map((d, i) => {
                        return <div onClick={(): void => setShowDescription(!showDescription)} className={'bv-object-view-mobile-facts bv-object-view-mobile-facts-description'} key={i} dangerouslySetInnerHTML={{ __html: d.value as string }}/>;
                    })}
                {!showDescription && <div id="bv-objectview-mobile-overlay" onClick={(): void => setShowDescription(!showDescription)}></div>}
                <p className="bv-objectview-mobile-overlay-text" >{!showDescription ? 'Visa mer' : 'Visa mindre'}</p>
            </>
        </div>
    );
};


export default ObjectViewMobileDescription;